import React from 'react';
import { IconWrapper } from '../runtime';
export default IconWrapper('arrow-down', false, function (props) {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 10 10",
    width: props.size,
    height: props.size
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 -1 0 8.4)",
    d: "M5 1L8.46410162 5.8 1.53589838 5.8z",
    fill: props.colors[0],
    fillRule: "evenodd"
  }));
});